//
// 计算DPR
// ============================================================
const DPR = () => {
    let html = document.documentElement;
    let pixclPatio = 1 / window.devicePixelRatio;
    document.write('<meta name="viewport" content="width=device-width,initial-scale=' + pixclPatio + ',minimum-scale=' + pixclPatio + ',maximum-scale=' + pixclPatio + ',user-scalable=no" />');
    let pageWidth = html.getBoundingClientRect().width;
    html.style.fontSize = pageWidth / 10 + 'px';
    html.setAttribute("data-dpr", window.devicePixelRatio);
};

module.exports = DPR;


// WEBPACK FOOTER //
// src/js/dpr.js